import { fromJS, Map, List } from 'immutable'

import { LOCATION_CHANGE } from 'react-router-redux'

import uuid from 'utils/uuid'

import {
  ADD_EXTRA_DATA,
  DELETE_EXTRA_DATA_FIELD,
  UPDATE_EXTRA_DATA_FIELD,
  IMPORT_EXTRA_DATA,
  EDITTING_POLICY,
} from './constants'


export const initialState = fromJS({
  extra_data: {},
  extra_data_order: [],
  editting: false
})


export default function reducer(state = initialState, action) {
  let extra_data, extra_data_order

  switch(action.type) {
    case UPDATE_EXTRA_DATA_FIELD:
      extra_data = state.get('extra_data')
      let updated_field = extra_data.get(action.id)

      if (action.isKey)
        updated_field = updated_field.set('key', action.inputValue)
      else
        updated_field = updated_field.set('value', action.inputValue)

      extra_data = extra_data.set(action.id, updated_field)
      return state.set('extra_data', extra_data)
    case DELETE_EXTRA_DATA_FIELD:
      extra_data = state.get('extra_data')
      extra_data_order = state.get('extra_data_order')

      // we must optimize this to avoid iteration over all items on the List
      extra_data_order = extra_data_order.filter((id) => action.id !== id)
      extra_data = extra_data.delete(action.id)
      return state.set('extra_data', extra_data)
                  .set('extra_data_order', extra_data_order)
    case ADD_EXTRA_DATA:
      const extraUUID = uuid()
      const row = Map({key: action.key, value: action.value})
      extra_data = state.get('extra_data')
      extra_data_order = state.get('extra_data_order')
      // this must be Immutable so  react-redux updates component after UPDATE_EXTRA_DATA_FIELD
      // react-redux createConnect use shallow equal
      extra_data = extra_data.set(extraUUID, row)
      // add UUID to keep adding order.
      extra_data_order = extra_data_order.push(extraUUID)
      return state.set('extra_data', extra_data)
                  .set('extra_data_order', extra_data_order)
    case IMPORT_EXTRA_DATA:
      const cleanedState = state.set('extra_data', Map({}))
                                .set('extra_data_order', List([]))
      return action.extraData.reduce((prevState, item) => reducer(prevState, {
        type: ADD_EXTRA_DATA,
        key: item.key,
        value: item.value
      }), cleanedState)
    case EDITTING_POLICY:
      return state.set('editting', action.editting)
    case LOCATION_CHANGE:
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Policy/reducer.js